import Box from '@mui/material/Box';
import { SubCategoryForm, SubCategoryFormProps } from 'kes-common';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import SidePopup from '@/components/SidePopup';
import { PropsOfRoute, application, applicationSubCategoryCreate } from '@/routes';
import { categoriesGet, studyId as studyIdSelector } from '@/selectors';
import { assetPersist } from '@/store/actions';
import State from '@/store/state';
import { Category } from '@/store/types';

const SubCategoryCreate: React.FC<PropsOfRoute<typeof applicationSubCategoryCreate>> = ({
	match,
}) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const category = useSelector<State, Category>((state) =>
		categoriesGet(state, match.params.categoryId),
	);
	const studyId = useSelector(studyIdSelector);
	const { enqueueSnackbar } = useSnackbar();

	const onSubmit = React.useCallback<SubCategoryFormProps['onSubmit']>(
		async (subCategory) => {
			dispatch(
				assetPersist({
					asset: subCategory,
					categoryId: category.id,
					position: category.assetTypeIds.length,
				}),
			);
			history.push(application({ applicationName: studyId }));
			enqueueSnackbar(`Sub-category '${subCategory.name}' created successfully`);
		},
		[category, dispatch, enqueueSnackbar, history, studyId],
	);

	return (
		<Box sx={{ bottom: 0, left: 0, position: 'absolute', right: 500, top: 0, width: 500 }}>
			<SidePopup title="Create Sub-category">
				<SubCategoryForm
					l10n={{
						actionPrimary: 'Create sub-category',
						fieldInformationHelperText:
							'This block of text will display in the activity, guiding the user through all questions within this sub-category',
						fieldInformationLabel: 'Info',
						fieldNameErrorRequired: 'Please fill in a name for the sub-category',
						fieldNameHelperText: 'Enter a name for the sub-category',
						fieldNameLabel: 'Sub-category name',
						fieldRepeatingHelperText:
							'A repeating sub-category can be added to a template, and will be rendered as a table in the resulting report.',
						fieldRepeatingLabel: 'Repeating',
					}}
					onSubmit={onSubmit}
				/>
			</SidePopup>
		</Box>
	);
};

export default SubCategoryCreate;
